// "FBO information" card of a charter booking: departure and arrival FBO.
import type { ReactNode } from 'react';
import { Card, Descriptions } from 'antd';

import type { CharterBookingDetail } from '../../api/types';
import { FboView } from '../../components/FboView';

export function FboCard({
  b,
  extra,
}: {
  b: CharterBookingDetail;
  extra: ReactNode;
}) {
  return (
    <Card
      title="FBO information"
      extra={extra}
    >
      <Descriptions bordered column={{ xs: 1, sm: 2 }} size="small">
        <Descriptions.Item label="Departure FBO"><FboView f={b.fbo?.departure} /></Descriptions.Item>
        <Descriptions.Item label="Arrival FBO"><FboView f={b.fbo?.arrival} /></Descriptions.Item>
      </Descriptions>
    </Card>
  );
}
